import { CAPTCHA_KEY, FORM_ID } from '../../../constants'
import Layout from '../../../components/Layout'
import {
  ADSHandler,
  CDA,
  DeviceFingerPrint,
  ReCaptchaProvider,
  ContextApp,
  AffiliateQueryStorage,
} from '@monorepo/service'
import { useContext } from 'react'

const App = () => {
  const {
    setSid,
    dataRegister,
    setDataRegister,
    setIsCdaPending,
    setIsCdaCheck,
    setIsCdaBalancerInfoLoading,
    setCdaBalancerInfo,
  } = useContext(ContextApp)

  return (
    <CDA
      dataRegister={dataRegister}
      setDataRegister={setDataRegister}
      setIsCdaPending={setIsCdaPending}
      setIsCdaCheck={setIsCdaCheck}
      setIsCdaBalancerInfoLoading={setIsCdaBalancerInfoLoading}
      setCdaBalancerInfo={setCdaBalancerInfo}
    >
      <DeviceFingerPrint setSid={setSid} triggerId={FORM_ID} />
      <AffiliateQueryStorage />
      <ADSHandler versions={{ v1: true, v2: true }} mania={'mania2'} />
      <ReCaptchaProvider reCaptchaKey={CAPTCHA_KEY} triggerId={FORM_ID}>
        <Layout />
      </ReCaptchaProvider>
    </CDA>
  )
}

export default App
